module.exports = __webpack_public_path__ + "media/companies/Sagard-98c8f899.png";